import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SectionLabel from '../components/SectionLabel';
import { aboutValueKeys, heroImage } from '../mock/data';
import { useLang } from '../i18n/LanguageContext';
import { Reveal } from '../hooks/useReveal';

export default function About() {
  const { t } = useLang();
  return (
    <main className="pt-32 lg:pt-40 pb-0 bg-cream">
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pb-24 lg:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal variant="left" className="lg:col-span-6">
            <div data-stagger="0"><SectionLabel>{t('common.ourStory')}</SectionLabel></div>
            <h1 data-stagger="1" className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[1.0] text-dark mb-10">
              {t('about.heading')}
            </h1>
            <div className="space-y-5 text-[15px] leading-relaxed text-muted-warm font-light">
              <p data-stagger="2">{t('about.p1')}</p>
              <p data-stagger="3">{t('about.p2')}</p>
            </div>
          </Reveal>
          <Reveal variant="right" className="lg:col-span-6 cinematic img-hover-zoom aspect-[4/5]">
            <img src={heroImage} alt="TL Event Group luxury tent" className="w-full h-full object-cover" />
          </Reveal>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-cream-soft border-y border-warm">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
          <Reveal variant="up" className="mb-14">
            <div data-stagger="0"><SectionLabel>{t('common.whatDefinesUs')}</SectionLabel></div>
            <h2 data-stagger="1" className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-dark">{t('about.valuesTitle')}</h2>
          </Reveal>
          <Reveal variant="fade" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-warm">
            {aboutValueKeys.map((k, i) => (
              <div key={k} data-stagger={i} className="bg-cream-soft p-8 lg:p-10">
                <p className="font-serif-display text-5xl text-gold mb-6">0{i + 1}</p>
                <h3 className="font-serif-display text-2xl text-dark mb-4">{t(`about.values.${k}.title`)}</h3>
                <p className="text-sm text-muted-warm leading-relaxed font-light">{t(`about.values.${k}.desc`)}</p>
              </div>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="py-20 lg:py-24 bg-cream">
        <Reveal variant="up" className="max-w-[1100px] mx-auto px-6 lg:px-12 text-center">
          <Link to="/contact" className="inline-flex items-center gap-2 text-[11px] tracking-luxury uppercase text-dark border border-dark px-8 py-4 hover:bg-dark hover:text-cream transition-colors duration-300 group">
            {t('cta.startProject')}
            <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
